import { ProcessingScreen } from '@components'

import { ReactElement } from 'react'

import { TableIds } from '../../../../enums/tableIds'
import { useHasImportedInvoices } from '../../hooks/useHasImportedInvoices'
import { ImportedInvoicesListEmpty } from '../ImportedInvoicesListEmpty'
import { useImportedInvoicesListData } from './context/importedInvoicesListData'
import { ImportedInvoicesTable } from './elements/ImportedInvoicesTable'
import { ImportedInvoicesTableActions } from './elements/ImportedInvoicesTableActions'

export const ImportedInvoicesListContent = (): ReactElement => {
  const { isLoading } = useImportedInvoicesListData()
  const { hasImportedInvoices, isLoading: isLoadingHasImportedInvoices } = useHasImportedInvoices()

  // Spinner only on initial load (`isLoading`), not background refetches (`keepPreviousData`).
  // Existence ignores list filters so fiscal-year/search zero-matches keep search + period mounted.
  if (isLoading || isLoadingHasImportedInvoices) {
    return <ProcessingScreen />
  }

  if (!hasImportedInvoices) {
    return <ImportedInvoicesListEmpty />
  }

  return (
    <>
      <ImportedInvoicesTableActions />
      <ImportedInvoicesTable tableId={TableIds.ImportedInvoicesList} />
    </>
  )
}
